var React = require('react');

function Pencil (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Shape"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Desktop","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"Homepage-Final-1-Copy","transform":"translate(-981.000000, -1121.000000)","fill":"#FFFFFF","fillRule":"nonzero"},React.createElement("path",{"d":"M981,1135.25052 L981,1139 L984.749479,1139 L995.807943,1127.94154 L992.058464,1124.19206 L981,1135.25052 Z M998.707541,1125.04194 C999.097486,1124.65199 999.097486,1124.02208 998.707541,1123.63213 L996.367866,1121.29246 C995.97792,1120.90251 995.348007,1120.90251 994.958061,1121.29246 L993.128316,1123.12221 L996.877795,1126.87168 L998.707541,1125.04194 Z","id":"Shape"})))]);
}

Pencil.defaultProps = {"width":"18px","height":"18px","viewBox":"0 0 18 18","version":"1.1"};

module.exports = Pencil;

Pencil.default = Pencil;
